<script setup>
import VariantImage from "@/Components/Blocks/ShoppingCart/VariantImage.vue";
import ProductButton from "@/Components/Product/ProductButton.vue";
import ProductInput from "@/Components/Product/ProductInput.vue";
import minus from '@i/minus.svg';
import plus from '@i/plus.svg';
import trash from '@i/trash.svg';
import {Link} from '@inertiajs/vue3';
import {inject} from 'vue';

const route = inject('route');

defineProps({
    variant: Object,
});

</script>

<template>
    <div class="grid w-full grid-cols-3">
        <Link
            :href="route('public.products.show', { product: variant.product?.page_slug ?? '' })"
            class="col-span-2 flex gap-4 lg:col-span-1"
        >
            <div class=" w-20 ">
                <div class="relative aspect-[80/96] bg-grey ">
                    <VariantImage
                        :variant="variant"
                    />
                </div>
            </div>
            <div class="grid flex-1 gap-2">
                <div>{{ variant.title }}</div>
                <div class="flex flex-col gap-2 md:flex-row md:items-center md:gap-4">
                    {{ $n(variant.current_display_price / 100, "currency").replace("€", "EUR") }}
                    <span
                        v-if="variant.discount_is_active"
                        class="text-sm font-normal line-through"
                    >
                        {{ $n(variant.display_price / 100, "currency").replace("€", "EUR") }}
                    </span>
                </div>

                <div class="grid gap-2 text-sm">
                    <div

                        v-for="product in variant.product_variants"
                        :key="product.id"
                    >
                        <Link
                            :href="route('public.products.show', { product: product.product?.page_slug ?? '' })"
                            class="underline"
                        >
                            {{ product.title }}
                        </Link>
                        <div
                            v-for="value in product.values"
                            :key="value.id"
                        >
                            {{ value.option.name }}: {{ value.name }}
                        </div>
                    </div>

                    <div
                        v-for="value in variant.values"
                        :key="value.id"
                    >
                        {{ value.option.name }}: {{ value.name }}
                    </div>
                </div>
            </div>
        </Link>


        <div class=" hidden items-start justify-end lg:flex">
            <div class="flex gap-4">
                <ProductButton
                    :variant="variant"
                    :quantity="variant.quantity - 1"
                    class="text-black"
                >
                    <img
                        class="w-4"
                        :src="minus"
                        :alt="$t('remove one')"
                    >
                </ProductButton>

                <ProductInput
                    :variant="variant"
                    :quantity="variant.quantity"
                />

                <ProductButton
                    :variant="variant"
                    :quantity="variant.quantity + 1"
                    class="text-black"
                >
                    <img
                        class="w-4"
                        :src="plus"
                        :alt="$t('add one')"
                    >
                </ProductButton>


                <ProductButton
                    :variant="variant"
                    :quantity="0"
                    class="text-black"
                >
                    <img
                        class="cursor-pointer"
                        :src="trash"
                        :alt="$t('remove product')"
                    >
                </ProductButton>
            </div>
        </div>

        <div class=" text-right ">
            {{ $n(variant.quantity * variant.current_display_price / 100, "currency").replace("€", "EUR") }}
        </div>
        <div class="flex-center col-span-full my-8 lg:hidden">
            <div class="flex gap-4">
                <ProductButton
                    :variant="variant"
                    :quantity="variant.quantity - 1"
                    class="text-black"
                >
                    <img
                        class="w-4"
                        :src="minus"
                        :alt="$t('remove one')"
                    >
                </ProductButton>

                <ProductInput
                    :variant="variant"
                    :quantity="variant.quantity"
                />

                <ProductButton
                    :variant="variant"
                    :quantity="variant.quantity + 1"
                    class="text-black"
                >
                    <img
                        class="w-4"
                        :src="plus"
                        :alt="$t('add one')"
                    >
                </ProductButton>


                <ProductButton
                    :variant="variant"
                    :quantity="0"
                    class="text-black"
                >
                    <img
                        class="cursor-pointer"
                        :src="trash"
                        :alt="$t('remove product')"
                    >
                </ProductButton>
            </div>
        </div>
    </div>
</template>
